"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  z50: "#FBF8FE",
  z100: "#F5ECFF",
  z200: "#DACBF9",
  z300: "#B89DF0",
  z400: "#8D68D6",
  z500: "#6C42C1",
  z600: "#5832A3",
  z700: "#482889",
  z800: "#361C6F",
  z900: "#27134E"
};
exports["default"] = _default;